import { _ } from "vue-underscore";

const state = {
  stateList: [
    {
      id: -3,
      name: "InProcess",
      human_name: "В процессе",
      in_progress: true,
      style: "s-in-process",
      row_style: "row-in-process"
    },
    {
      id: -1,
      name: "Rejected",
      human_name: "Отклонен",
      in_progress: false,
      style: "s-rejected",
      row_style: "row-rejected"
    },
    {
      id: 0,
      name: "NONE",
      human_name: "Без статуса",
      in_progress: true,
      style: "s-none",
      row_style: ""
    },
    {
      id: 1,
      name: "NEW",
      human_name: "Новый",
      in_progress: false,
      style: "s-new",
      row_style: "row-new"
    },
    {
      id: 2,
      name: "AUTHORIZING",
      human_name: "Авторизация",
      in_progress: true,
      style: "s-authorizing",
      row_style: ""
    },
    {
      id: 3,
      name: "AUTHORIZED",
      human_name: "Авторизован",
      in_progress: false,
      style: "s-authorized",
      row_style: "row-authorized"
    },
    {
      id: 4,
      name: "PREAUTHORIZED3DS",
      human_name: "Предавторизация 3DS",
      in_progress: false,
      style: "s-preauthorized",
      row_style: "row-preauthorized"
    },
    {
      id: 5,
      name: "VOIDING",
      human_name: "Отмена",
      in_progress: true,
      style: "s-voiding",
      row_style: ""
    },
    {
      id: 6,
      name: "VOIDED",
      human_name: "Отменен",
      in_progress: false,
      style: "s-voided",
      row_style: "row-voided"
    },
    {
      id: 7,
      name: "CHARGING",
      human_name: "Списание",
      in_progress: true,
      style: "s-charging",
      row_style: ""
    },
    {
      id: 8,
      name: "CHARGED",
      human_name: "Списан",
      in_progress: false,
      style: "s-charged",
      row_style: "row-charged"
    },
    {
      id: 9,
      name: "REFUNDING",
      human_name: "Возвращается",
      in_progress: true,
      style: "s-refunding",
      row_style: ""
    },
    {
      id: 10,
      name: "REFUNDED",
      human_name: "Возвращен",
      in_progress: false,
      style: "s-refund",
      row_style: "row-refund"
    },
    {
      id: 11,
      name: "FORWARDING",
      human_name: "Переадресация",
      in_progress: true,
      style: "s-forwarding",
      row_style: ""
    },
    {
      id: 12,
      name: "FORWARDED",
      human_name: "Переадресован",
      in_progress: false,
      style: "s-none",
      row_style: "row-forwarded"
    },
    {
      id: 13,
      name: "VERIFYING PAYOUT OPPORTUNITY",
      human_name: "Проверка возможности выплаты",
      in_progress: true,
      style: "s-verifying",
      row_style: ""
    },
    {
      id: 14,
      name: "PAYOUT READY",
      human_name: "Готово к выплате",
      in_progress: false,
      style: "s-payoutrdy",
      row_style: "row-payoutrdy"
    },
    {
      id: 15,
      name: "PAYING",
      human_name: "Выплата",
      in_progress: true,
      style: "s-paying",
      row_style: ""
    },
    {
      id: 16,
      name: "PAID",
      human_name: "Выплачен",
      in_progress: false,
      style: "s-paid",
      row_style: "row-paid"
    },
    {
      id: 17,
      name: "Verifying Payment Opportunity",
      human_name: "Проверка возможности оплаты",
      in_progress: true,
      style: "s-verifying-ips",
      row_style: ""
    },
    {
      id: 18,
      name: "Payment Ready",
      human_name: "Возможность оплаты подтверждена",
      in_progress: false,
      style: "s-payoutrdy-ips",
      row_style: "row-payoutrdy-ips"
    },
    {
      id: 19,
      name: "Paying",
      human_name: "Оплата",
      in_progress: true,
      style: "s-paying-ips",
      row_style: ""
    },
    {
      id: 20,
      name: "Paid",
      human_name: "Оплачено",
      in_progress: false,
      style: "s-paid-ips",
      row_style: "row-paid-ips"
    },
    {
      id: 22,
      name: "Rectification",
      human_name: "Уточнение",
      in_progress: true,
      style: "s-none",
      row_style: "row-forwarded"
    }
  ]
};

const getters = {
  statusList(state) {
    return state.stateList;
  },
  statusName: state => id => {
    if (state.stateList && state.stateList.length > 0 && id != null) {
      let stateItem = state.stateList.find(el => el.id === id);
      return stateItem ? stateItem.human_name : `[${id}] Unknown`;
    } else {
      return "Unknown";
    }
  },
  statusStyle: state => id => {
    if (state.stateList && state.stateList.length > 0 && id != null) {
      let stateItem = state.stateList.find(el => el.id === id);
      return stateItem ? stateItem.style : "s-none";
    } else {
      return "s-none";
    }
  },
  rowStyle: state => id => {
    if (state && id) {
      let stateItem = state.stateList.find(el => el.id === id);
      return stateItem ? stateItem.row_style : "";
    }
    return "";
  },
  isInProgress: state => id => {
    if (state.stateList && id) {
      let stateItem = state.stateList.find(el => el.id === id);
      return stateItem ? stateItem.in_progress : false;
    }
    return false;
  }
};

export default {
  state,
  getters
};
